// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_4i-0";
export var orangeButton = "_4i-1";